import { Component, Inject } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { MatInputModule } from '@angular/material/input'

@Component({
  selector: 'app-comment-dialog',
  templateUrl: './comment-dialog.component.html',
  styleUrls: ['./comment-dialog.component.scss'],
  imports: [MatDialogModule, MatButtonModule, MatInputModule, FormsModule],
})
export class CommentDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<CommentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; comment: string },
  ) {}

  onCancel(): void {
    this.dialogRef.close()
  }

  onSave(): void {
    this.dialogRef.close(this.data.comment)
  }
}
